import TeacherScreen from "./TeacherScreen";
export default TeacherScreen;
